import { axiosFetch } from './axiosFetch';
import { getHeaders, parseURLParams, postHeaders, urlModifier } from '../utils';
import API_CONSTANTS from '../constants/apiConstants';

export const bulkExportProjects = async ({
  bulkRequestId,
  displineID,
  themeID,
  requester,
  projects
}) => {
  const apiPath = API_CONSTANTS.BULK_EXPORT_TO_PDF;
  const reqOptions = {
    ...postHeaders(),
    body: {
      bulkRequestId,
      displineID,
      themeID,
      requester,
      projects
    }
  };
  return axiosFetch(reqOptions, apiPath);
};

export const getBulkExportStatusByUser = async apiParams => {
  const url = API_CONSTANTS.BULK_EXPORT_STATUS_TRACK;
  const apiPath = urlModifier(url);
  const reqOptions = {
    ...getHeaders()
  };

  // eslint-disable-next-line no-unused-vars
  const response = await axiosFetch(reqOptions, apiPath, apiParams);
  return response.data;
};

export const getBulkExportStatusByBulkId = async apiParams => {
  const apiEndpoint = API_CONSTANTS.BULK_EXPORT_STATUS_TRACK_WITH_BULK_ID;
  const replacement = { '%bulkRequestId%': apiParams.bulkRequestId };
  const url = parseURLParams(replacement, apiEndpoint);
  const apiPath = urlModifier(url);

  const params = {
    page: apiParams.page,
    pageSize: apiParams.pageSize
  };

  const reqOptions = {
    ...getHeaders()
  };
  // eslint-disable-next-line no-unused-vars
  const response = await axiosFetch(reqOptions, apiPath, params);
  return response.data;
};
